import Aos from "aos";
import 'slick-carousel';

jQuery( document ).ready(function($) {
    $('.menu-toggle').on('click', function(e){
        $('#header .menu').toggleClass('open');
        $('.search-wrapper').removeClass('open');
    })

    // SOCIAL WIDGET TABS
    $('.social-widget .tab').on('click', function (e) { 
        e.preventDefault();
        $('.social-widget .tab, .social-widget .view').removeClass('active');
        $(this).addClass('active');
        const viewId = $(this).attr('href');
        $(viewId).addClass('active');
    });

    //News Carousel
    $('.news-carousel').slick({
        slidesToShow: 3,
        variableWidth: false,
        centerMode: true,
        initialSlide: 1,
        arrows: true,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous"><i class="fal fa-chevron-circle-left"></i></button>',
        nextArrow:'<button type="button" class="slick-next" aria-label="Next"><i class="fal fa-chevron-circle-right"></i></button>',
        responsive:[
            {
            breakpoint: 1400,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
            breakpoint: 760,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
            }
        ]
    })


    //Footer Offices
    $('.offices .office-info').hide();
    $('.offices .office-info:first-child').show();
    
    $('.office-select').on('mouseover', function(e){
        e.preventDefault();
        $('.offices .office-info').hide();
        let target = $(this).attr('href'); 
        $(target).show();
    })


    Aos.init();
});